import { Button } from "@/components/ui/button";
import { CalendarCheck } from "lucide-react";

export default function StickyCTA({ visible }) {
  const scrollToBooking = () => {
    const el = document.querySelector("#termin-buchen");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      data-testid="sticky-cta"
      className={`fixed bottom-0 left-0 right-0 z-40 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="bg-white/95 backdrop-blur-xl border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-4">
          <div className="hidden sm:block">
            <p className="text-sm font-semibold text-slate-800">Kostenlose Pflegeberatung per Video</p>
            <p className="text-xs text-slate-500">Jetzt freien Termin sichern</p>
          </div>
          <Button
            data-testid="sticky-cta-btn"
            onClick={scrollToBooking}
            className="bg-cyan-700 hover:bg-cyan-600 text-white rounded-xl px-6 py-2.5 text-sm font-semibold shadow-sm hover:shadow-md transition-all flex items-center gap-2 sm:ml-auto"
          >
            <CalendarCheck className="h-4 w-4" />
            Jetzt Termin buchen
          </Button>
        </div>
      </div>
    </div>
  );
}
